import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Button from '@opsbase/web-ui/Button';
import React, { useCallback, useState } from 'react';
import WorkflowModel from "@opsbase/lib-data-model/models/WorkflowModel";
import useWorkflowUpdate from "@opsbase/react-gql-hooks/workflow/useWorkflowUpdate";
import Horizontal from "@opsbase/web-layout/Horizontal/Horizontal";
import Text from "@opsbase/web-ui/Text/Text";
import Card from "@opsbase/web-layout/Card/Card";
import Vertical from "@opsbase/web-layout/Vertical/Vertical";
import Pane from "@opsbase/web-layout/Pane/Pane";
import DatePicker from "@opsbase/web-pickers/DatePicker/DatePicker";
import TimePicker from "@opsbase/web-pickers/DatePicker/TimePicker";
import RepetitionTypePicker from "@opsbase/web-op-scheduler/OpScheduleEditor/RepetitionTypePicker";
import moment from "moment-timezone";
import WorkflowSchedule from "@opsbase/lib-workflow/WorkflowSchedule";
export function WorkflowScheduleEditDialog(props) {
    var _a;
    const { workflow, onClose } = props;
    const [localWorkflow, setLocalWorkflow] = useState(new WorkflowModel(workflow));
    const updateWorkflow = useWorkflowUpdate();
    const dueDate = moment((_a = localWorkflow === null || localWorkflow === void 0 ? void 0 : localWorkflow.schedule) === null || _a === void 0 ? void 0 : _a.dueDate);
    const [dueDateDate, setDueDateDate] = useState(dueDate);
    const [dueDateTime, setDueDateTime] = useState(dueDate);
    const [busy, setBusy] = useState(false);
    const handleClickCancel = useCallback(() => onClose === null || onClose === void 0 ? void 0 : onClose(), [onClose]);
    const handleChangeDueDateDate = useCallback(value => {
        if (value.isValid()) {
            value
                .hours(dueDate.hours())
                .minutes(dueDate.minutes())
                .seconds(dueDate.seconds())
                .milliseconds(dueDate.milliseconds());
            setDueDateTime(value);
            setLocalWorkflow(new WorkflowModel({
                ...localWorkflow,
                schedule: new WorkflowSchedule({ ...localWorkflow.schedule, dueDate: value })
            }));
        }
        setDueDateDate(value);
    }, [dueDate, localWorkflow]);
    const handleChangeDueDateTime = useCallback(value => {
        if (value.isValid()) {
            value.year(dueDate.year()).month(dueDate.month()).day(dueDate.day());
            setDueDateDate(value);
            setLocalWorkflow(new WorkflowModel({
                ...localWorkflow,
                schedule: new WorkflowSchedule({ ...localWorkflow.schedule, dueDate: value })
            }));
        }
        setDueDateTime(value);
    }, [dueDate, localWorkflow]);
    const handleChangeRepetitionType = useCallback(value => {
        setLocalWorkflow(new WorkflowModel({
            ...localWorkflow,
            schedule: new WorkflowSchedule({ ...localWorkflow.schedule, ...value })
        }));
    }, [localWorkflow]);
    const handleClickSave = useCallback(() => {
        const l = localWorkflow;
        setBusy(true);
        updateWorkflow({
            id: l.id,
            patch: {
                schedule: l.schedule
            },
        })
            .catch(doNothing)
            .finally(() => {
            setBusy(false);
            //	onChange?.()
            onClose === null || onClose === void 0 ? void 0 : onClose();
        });
    }, [localWorkflow, onClose, updateWorkflow]);
    return (React.createElement(Dialog, { ...props, closable: false, padded: false, title: i18n.t('edit-schedule'), size: DialogSize.X1000_Y500, buttonsLeft: React.createElement(Button, { label: i18n.t('cancel'), disabled: busy, color: Palette.Grey, onClick: handleClickCancel }), buttonsRight: React.createElement(Button, { disabled: busy, label: i18n.t('save'), color: Palette.positive, onClick: handleClickSave }) },
        React.createElement(Vertical, { gutter: true, padding: true },
            React.createElement(Horizontal, { shrink: true, gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
                React.createElement(Text, { variant: "h1" }, i18n.t('when'))),
            React.createElement(Card, { padding: true },
                React.createElement(Vertical, { paddingY: true, gutter: true },
                    React.createElement(Pane, { style: { width: '50%' } },
                        React.createElement(Text, { variant: "h2" }, i18n.t('start-from')),
                        React.createElement(Horizontal, null,
                            React.createElement(DatePicker, { timezone: 'UTC', noMargin: true, value: dueDateDate, onChange: handleChangeDueDateDate }),
                            React.createElement(TimePicker, { timezone: 'UTC', noMargin: true, value: dueDateTime, onChange: handleChangeDueDateTime }))),
                    React.createElement(Pane, null,
                        React.createElement(Text, { variant: "h2" }, i18n.t('repeats')),
                        React.createElement(RepetitionTypePicker, { schedule: localWorkflow.schedule, onChange: handleChangeRepetitionType })))))));
}
export default WorkflowScheduleEditDialog;
